// extracted by mini-css-extract-plugin
export default {"__wrapper":"PatientInfo___wrapper__cPApY","__list":"PatientInfo___list__B7ODJ"};